import React from 'react';
import { ContentHeader, StorageHandler } from 'C4';
import i18n from 'i18n-react';
import { baseAppId, storageKeys } from 'settings';

const OffersView = () => {
  const offerButtons = [
    {
      title: 'Attraction Offers',
      link: 'https://travproconnect.com/profile/1162',
      img: 'https://front.travpromobile.com/743/attraction-offers.jpg?q=90&auto=format&w=800&h=auto',
    },
    {
      title: 'Hotel Offers',
      link: 'https://travproconnect.com/profile/1163',
      img: 'https://front.travpromobile.com/743/hotel-offers.jpg?q=90&auto=format&w=800&h=auto',
    },
    {
      title: 'Shopping & Dining',
      link: 'https://travproconnect.com/profile/1164',
      img: 'https://front.travpromobile.com/743/ShoppingandDining.jpg?q=90&auto=format&w=800&h=auto',
    },
    {
      title: 'Transportation Offers',
      link: 'https://travproconnect.com/profile/1548',
      img: 'https://front.travpromobile.com/743/TransportationImage.jpg?q=90&auto=format&w=800&h=auto',
    },
  ];

  const handleMobile = async (link) => {
    try {
      const lang = await StorageHandler.load(storageKeys.lang);
      window.postMessage(
        `webview:${link}?app_id=${baseAppId}&lang=${lang.langFile}&mobile=true`,
        '*',
      );
      window.ReactNativeWebView.postMessage(
        `webview:${link}?app_id=${baseAppId}&lang=${lang.langFile}&mobile=true`,
        '*',
      );
    } catch (error) {
      // Handle errors here
      console.error('Error:', error);
    }
  };
  
  return (
    <div className="offersView contentContainer">
      <div className="darken" />

      <ContentHeader header={i18n.translate('nav.offers')} line />
      <div className="offersView__content">
        {offerButtons &&
          offerButtons.map((button, i) => {
            const key = i;

            if (button.title === '') {
              return (
                <a className="offersView__content--button">
                  <div className="coming">Coming Soon</div>
                  <img src={button.img} alt={button.title} />
                  {button.title}
                </a>
              );
            }

            if (window.location.href.includes('mobile')) {
              return (
                <a
                  key={key}
                  className="offersView__content--button"
                  onClick={() => handleMobile(button.link)}
                >
                  <img src={button.img} alt={button.title} />
                  {button.title}
                </a>
              );
            }
            
            return (
              <a
                key={key}
                className="offersView__content--button"
                data-fancybox={button.title}
                data-type="iframe"
                href={button.link}
              >
                <img src={button.img} alt={button.title} />
                {button.title}
              </a>
            );
          })}
      </div>
      {window.location.href.includes('mobile') &&
        <style>{'\
        .offersView__content { margin-left: 5rem !important; margin-right: 5rem !important; width: calc(100% - 10rem); } .header { display: none !important; } .contentContainer { margin-top: 0 !important; } .cookieConsent--content { display: none !important; } .mt-1 { margin-top: 2.5rem } input { font-size: 16px !important; } .loginView__content { width: 100% !important; opacity: 1 !important; } .buttonWrapper { display:none !important; } .loginView__content--logo { display: none !important; } .btnInverse { display: none !important; } .cookieConsent { display: none; bottom: 4rem; } .register { display: none !important; } .loginView .loginView__bg .loginView__bg--content .buttonWrapper img { display: none !important; }  #openWidget { display: none !important; } .loginView__bg { display: none !important; } .loginView { display:block !important; }'}
        </style>
        }
    </div>
  );
};

export default OffersView;
